module.exports = __webpack_public_path__ + "media/icons/zmiana-rejestracji@3x-9817516e.svg";